var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('height:' +
            _vm.height +
            'px')},[_c('poster',{attrs:{"src":_vm.src,"config":_vm.config,"promotionType":_vm.campaign.promotionType.promotionType,"height":_vm.height,"aspectRatio":_vm.aspectRatio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }